import groundcover from '@groundcover/browser'
import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import defu from 'defu'

export type GroundcoverParams = NonNullable<
  Parameters<typeof groundcover.init>[0]
>

export default defineNuxtPlugin({
  name: 'nuxt-groundcover',
  setup() {
    const options = useRuntimeConfig().public.groundcover

    const groundcoverParams = defu(options.config, {
      dsn: 'https://tevicq4nl.platform.grcv.io',
      cluster: 'workflows-apps',
      options: {
        privacy: {
          level: 'mask-sensitive',
          // TODO(WFL-7311): We may want to change this selector
          maskSelectors: ['[data-dd-privacy="mask"]'],
        },
      },
    }) as GroundcoverParams

    groundcover.init(groundcoverParams)

    groundcover.startReplayRecording()

    return {
      provide: {
        groundcover,
      },
    }
  },
})
